import React, { useEffect, useState } from 'react'
import TextArea from 'antd/es/input/TextArea'
import { useUpdateQuestionAnswerReasoningMutation } from '../../../../../../../../../../store/apis/submission.api'

const useSyncReasoning = initialValue => {
    const [reasoning, setReasoning] = useState('')

    useEffect(() => {
        setReasoning(initialValue || '')
    }, [initialValue])

    return [reasoning, setReasoning]
}

const ReasoningInput = ({ submissionId, answerId, initialValue, readonly }) => {
    const [reasoning, setReasoning] = useSyncReasoning(initialValue)
    const [updateQuestionAnswerReasoning, updateQuestionAnswerReasoningResult] =
        useUpdateQuestionAnswerReasoningMutation()

    const savedStatus = useDisappearingSavedStatus(updateQuestionAnswerReasoningResult)

    const handleBlur = () => {
        const reasoningHasChanged = reasoning !== initialValue
        if (reasoningHasChanged) updateQuestionAnswerReasoning({ id: answerId, submissionId, reasoning })
    }

    const handleChange = event => {
        if (readonly) return
        setReasoning(event.target.value)
    }

    const reasoningChanged = reasoning !== initialValue

    const status = (() => {
        if (updateQuestionAnswerReasoningResult.isLoading) return 'Saving...'
        if (updateQuestionAnswerReasoningResult.isError) return updateQuestionAnswerReasoningResult.error
        if (reasoningChanged) return 'Edited'
        return savedStatus
    })()

    return (
        <div>
            <div className='text-area-title'>Reasoning</div>
            <TextArea
                value={reasoning}
                onChange={handleChange}
                onBlur={handleBlur}
                autoSize
                placeholder='Enter reasoning for this answer'
                disabled={updateQuestionAnswerReasoningResult.isLoading}
                className='reasoning'
                title='Reasoning'
            />
        </div>
    )
}

function useDisappearingSavedStatus(updateQuestionAnswerResult) {
    const [savedStatus, setSavedStatus] = useState('')

    useEffect(() => {
        if (updateQuestionAnswerResult.isSuccess) {
            setSavedStatus('Saved')
            const timer = setTimeout(() => setSavedStatus(''), 3000)
            return () => clearTimeout(timer)
        }
    }, [updateQuestionAnswerResult])

    return savedStatus
}

export default ReasoningInput
